<template>
  <div class="content content-fixed content-auth-alt">
    <div class="container d-flex justify-content-center ht-100p">
      <div
        class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/img/img18.png" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 tx-sm-24">Нууц үг сэргээх</h4>
        <p class="tx-color-03 mg-b-40">
          Та бүртгэлтэй и-мэйл хаягаа оруулна уу.
        </p>
        <!-- <p class="text-muted tx-color-03"></p> -->
        <div class="wd-100p d-flex flex-column flex-sm-row mg-b-40">
          <input
            v-model="userName"
            type="text"
            class="form-control wd-sm-250 flex-fill"
            placeholder="Бүртгэлтэй и-мэйл хаягаа оруулна уу"
          />
          <button
            class="btn btn-brand-02 mg-sm-l-10 mg-t-10 mg-sm-t-0"
            @click="send"
          >
            Илгээх
          </button>
        </div>
        <span class="tx-12 tx-color-03"
          >жич: Нууц үг сэргээх холбоос и-мэйл таны INBOX folder-т очоогүй бол
          SPAM folder-оо шалгана уу.</span
        >
        <span class="tx-12 tx-color-03"
          >Бүртгэлээ санаж буй бол
          <router-link to="/login">Нэвтрэх</router-link></span
        >
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";
import { localRead } from "@/libs/util";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userName: ""
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    send() {
      this.handleLoading({ isLoading: true });

      request({
        api: { method: "POST", url: "User/ForgotAPI" },
        params: {
          user: this.userName
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          Notification.success({
            message:
              "Таны и-мэйл хаяг руу нууц үг сэргээх холбоос илгээлээ. И-мэйл хаягаа шалгана уу",
            title: "Амжилттай",
            duration: 30000,
            type: "success",
            position: "top-right",
            offset: 50
          });
          this.$router.push({ name: "login" });
        }
      });
    }
    // renew() {
    //   this.handleLoading({ isLoading: true });
    //   request({
    //     api: { method: "POST", url: "User/getNewActivationKey" },
    //     data: {
    //       key: this.code,
    //       userId: localRead("activationUserId"),
    //       groupId: localRead("activationGroupId")
    //     },
    //     store: this.$store
    //   }).then(res => {
    //     this.handleLoading({ isLoading: false });
    //     if (res != false) {
    //       Notification.success({
    //         message:
    //           "Таны и-мэйл хаяг руу шинэ баталгаажуулах код илгээлээ. И-мэйл хаягаа шалгана уу",
    //         title: "Амжилттай",
    //         duration: 60000,
    //         type: "success",
    //         position: "top-right",
    //         offset: 50
    //       });
    //     }
    //   });
    // }
  }
};
</script>
